import * as Sentry from "@sentry/react";

import React from "react";
import { isExpectedClientError } from "./services/errorClassification";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { installStaleDeployReload } from "./services/staleDeployReload";

// A tab opened before a deploy reloads itself instead of showing an error when it
// navigates to a page whose chunk that deploy removed.
installStaleDeployReload();

// AG Grid module registration lives in components/shared/agGrid.js so it (and
// the AG Grid bundle) loads only with the lazy routes that render a grid.

if (process.env.REACT_APP_ENV === "production") {
  Sentry.init({
    dsn: "https://2f23581a2a6e97726fd5b8d2b80c7416@o4507508246839297.ingest.de.sentry.io/4507889370660944",
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1.0,
    // tracePropagationTargets: [/^https:\/\/database\.biteg\.de/],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    // Hard gate: expected client-level errors (a wrong-password login, a 404, a
    // validation 400) are user-facing, never faults. Drop them however they
    // arrive — including via the SDK's default unhandled-error/rejection
    // handlers, which the api-interceptor gate alone can't intercept.
    beforeSend(event, hint) {
      if (isExpectedClientError(hint?.originalException)) return null;
      return event;
    },
  });
} else {
  // Sentry is disabled in development mode
}

// #root is always present in index.html; assert non-null so createRoot's
// Element argument is satisfied.
const container = document.getElementById("root")!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
